(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlinx-serialization-kotlinx-serialization-core.js', './kotlin-kotlin-stdlib.js', './fixers-s2-s2-automate-s2-automate-dsl.js', './fixers-f2-f2-dsl-f2-dsl-cqrs.js', './boislocal-platform-platform-infra-commons-commons-domain.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlinx-serialization-kotlinx-serialization-core.js'), require('./kotlin-kotlin-stdlib.js'), require('./fixers-s2-s2-automate-s2-automate-dsl.js'), require('./fixers-f2-f2-dsl-f2-dsl-cqrs.js'), require('./boislocal-platform-platform-infra-commons-commons-domain.js'));
  else {
    if (typeof this['kotlinx-serialization-kotlinx-serialization-core'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-s2-btmcOrganization-btmcOrganization-domain'. Its dependency 'kotlinx-serialization-kotlinx-serialization-core' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-core' is loaded prior to 'boislocal-platform-platform-s2-btmcOrganization-btmcOrganization-domain'.");
    }
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-s2-btmcOrganization-btmcOrganization-domain'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'boislocal-platform-platform-s2-btmcOrganization-btmcOrganization-domain'.");
    }
    if (typeof this['fixers-s2-s2-automate-s2-automate-dsl'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-s2-btmcOrganization-btmcOrganization-domain'. Its dependency 'fixers-s2-s2-automate-s2-automate-dsl' was not found. Please, check whether 'fixers-s2-s2-automate-s2-automate-dsl' is loaded prior to 'boislocal-platform-platform-s2-btmcOrganization-btmcOrganization-domain'.");
    }
    if (typeof this['fixers-f2-f2-dsl-f2-dsl-cqrs'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-s2-btmcOrganization-btmcOrganization-domain'. Its dependency 'fixers-f2-f2-dsl-f2-dsl-cqrs' was not found. Please, check whether 'fixers-f2-f2-dsl-f2-dsl-cqrs' is loaded prior to 'boislocal-platform-platform-s2-btmcOrganization-btmcOrganization-domain'.");
    }
    if (typeof this['boislocal-platform-platform-infra-commons-commons-domain'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-s2-btmcOrganization-btmcOrganization-domain'. Its dependency 'boislocal-platform-platform-infra-commons-commons-domain' was not found. Please, check whether 'boislocal-platform-platform-infra-commons-commons-domain' is loaded prior to 'boislocal-platform-platform-s2-btmcOrganization-btmcOrganization-domain'.");
    }
    root['boislocal-platform-platform-s2-btmcOrganization-btmcOrganization-domain'] = factory(typeof this['boislocal-platform-platform-s2-btmcOrganization-btmcOrganization-domain'] === 'undefined' ? {} : this['boislocal-platform-platform-s2-btmcOrganization-btmcOrganization-domain'], this['kotlinx-serialization-kotlinx-serialization-core'], this['kotlin-kotlin-stdlib'], this['fixers-s2-s2-automate-s2-automate-dsl'], this['fixers-f2-f2-dsl-f2-dsl-cqrs'], this['boislocal-platform-platform-infra-commons-commons-domain']);
  }
}(this, function (_, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core, kotlin_kotlin, kotlin_io_komune_s2_s2_automate_dsl, kotlin_io_komune_f2_f2_dsl_cqrs, kotlin_org_boislocal_commons_domain) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var createSimpleEnumSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.c2;
  var LazyThreadSafetyMode_PUBLICATION_getInstance = kotlin_kotlin.$_$.i;
  var lazy = kotlin_kotlin.$_$.ge;
  var protoOf = kotlin_kotlin.$_$.fa;
  var SerializerFactory = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.b2;
  var objectMeta = kotlin_kotlin.$_$.ea;
  var setMetadataFor = kotlin_kotlin.$_$.ga;
  var VOID = kotlin_kotlin.$_$.g;
  var THROW_IAE = kotlin_kotlin.$_$.ld;
  var Unit_instance = kotlin_kotlin.$_$.t4;
  var Enum = kotlin_kotlin.$_$.zc;
  var defineProp = kotlin_kotlin.$_$.b9;
  var S2State = kotlin_io_komune_s2_s2_automate_dsl.$_$.j;
  var classMeta = kotlin_kotlin.$_$.z8;
  var S2TransitionBuilder = kotlin_io_komune_s2_s2_automate_dsl.$_$.b;
  var toValue = kotlin_io_komune_s2_s2_automate_dsl.$_$.m;
  var toValue_0 = kotlin_io_komune_s2_s2_automate_dsl.$_$.n;
  var getKClass = kotlin_kotlin.$_$.f;
  var toValue_1 = kotlin_io_komune_s2_s2_automate_dsl.$_$.l;
  var S2Transition = kotlin_io_komune_s2_s2_automate_dsl.$_$.k;
  var S2SelfTransitionBuilder = kotlin_io_komune_s2_s2_automate_dsl.$_$.a;
  var collectionSizeOrDefault = kotlin_kotlin.$_$.j5;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.k;
  var s2Sourcing = kotlin_io_komune_s2_s2_automate_dsl.$_$.c;
  var PluginGeneratedSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.z1;
  var StringSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.r;
  var UnknownFieldException_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e;
  var THROW_CCE = kotlin_kotlin.$_$.kd;
  var typeParametersSerializers = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.u1;
  var GeneratedSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.v1;
  var throwMissingFieldException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e2;
  var objectCreate = kotlin_kotlin.$_$.da;
  var S2Role = kotlin_io_komune_s2_s2_automate_dsl.$_$.i;
  var S2Command = kotlin_io_komune_s2_s2_automate_dsl.$_$.g;
  var interfaceMeta = kotlin_kotlin.$_$.k9;
  var WithS2Id = kotlin_io_komune_s2_s2_automate_dsl.$_$.e;
  var Event = kotlin_io_komune_f2_f2_dsl_cqrs.$_$.d;
  var getStringHashCode = kotlin_kotlin.$_$.i9;
  var $serializer_getInstance = kotlin_org_boislocal_commons_domain.$_$.g;
  var get_nullable = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.v;
  var LongSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.q;
  var Long = kotlin_kotlin.$_$.ed;
  var equals = kotlin_kotlin.$_$.c9;
  var S2InitCommand = kotlin_io_komune_s2_s2_automate_dsl.$_$.h;
  var $serializer_getInstance_0 = kotlin_org_boislocal_commons_domain.$_$.c;
  var $serializer_getInstance_1 = kotlin_org_boislocal_commons_domain.$_$.i;
  var WithS2State = kotlin_io_komune_s2_s2_automate_dsl.$_$.f;
  var ArrayListSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.s1;
  var hashCode = kotlin_kotlin.$_$.j9;
  var Roles_instance = kotlin_org_boislocal_commons_domain.$_$.b;
  var hasRole = kotlin_org_boislocal_commons_domain.$_$.m;
  var ensureNotNull = kotlin_kotlin.$_$.be;
  var isAvailableTransition = kotlin_io_komune_s2_s2_automate_dsl.$_$.d;
  var Query = kotlin_io_komune_f2_f2_dsl_cqrs.$_$.e;
  var PageQueryDTO = kotlin_io_komune_f2_f2_dsl_cqrs.$_$.a;
  var PageQueryResultDTO = kotlin_io_komune_f2_f2_dsl_cqrs.$_$.b;
  //endregion
  //region block: pre-declaration
  setMetadataFor(Companion, 'Companion', objectMeta, VOID, [SerializerFactory]);
  setMetadataFor(BtmcOrganizationState, 'BtmcOrganizationState', classMeta, Enum, [Enum, S2State], VOID, VOID, {0: Companion_getInstance});
  setMetadataFor(S2, 'S2', objectMeta);
  setMetadataFor(UserRole, 'UserRole', classMeta, VOID, [S2Role], VOID, VOID, {0: $serializer_getInstance_2});
  setMetadataFor(User, 'User', objectMeta, UserRole);
  setMetadataFor(Companion_0, 'Companion', objectMeta);
  setMetadataFor($serializer, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(BtmcOrganizationAssignBtmcNumberCommandDTO, 'BtmcOrganizationAssignBtmcNumberCommandDTO', interfaceMeta, VOID, [S2Command]);
  setMetadataFor(BtmcOrganizationAssignedBtmcNumberEventDTO, 'BtmcOrganizationAssignedBtmcNumberEventDTO', interfaceMeta, VOID, [WithS2Id, Event]);
  setMetadataFor(BtmcOrganizationAssignBtmcNumberCommand, 'BtmcOrganizationAssignBtmcNumberCommand', classMeta, VOID, [BtmcOrganizationAssignBtmcNumberCommandDTO]);
  setMetadataFor(Companion_1, 'Companion', objectMeta);
  setMetadataFor($serializer_0, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(BtmcOrganizationAssignedBtmcNumberEvent, 'BtmcOrganizationAssignedBtmcNumberEvent', classMeta, VOID, [BtmcOrganizationAssignedBtmcNumberEventDTO], VOID, VOID, {0: $serializer_getInstance_3});
  setMetadataFor(BtmcOrganizationImportCommandDTO, 'BtmcOrganizationImportCommandDTO', interfaceMeta, VOID, [S2InitCommand]);
  setMetadataFor(BtmcOrganizationImportedEventDTO, 'BtmcOrganizationImportedEventDTO', interfaceMeta, VOID, [WithS2Id, Event]);
  setMetadataFor(Companion_2, 'Companion', objectMeta);
  setMetadataFor($serializer_1, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(BtmcOrganizationImportCommand, 'BtmcOrganizationImportCommand', classMeta, VOID, [BtmcOrganizationImportCommandDTO], VOID, VOID, {0: $serializer_getInstance_4});
  setMetadataFor(Companion_3, 'Companion', objectMeta);
  setMetadataFor($serializer_2, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(BtmcOrganizationImportedEvent, 'BtmcOrganizationImportedEvent', classMeta, VOID, [BtmcOrganizationImportedEventDTO], VOID, VOID, {0: $serializer_getInstance_5});
  setMetadataFor(BtmcOrganizationInitCommandDTO, 'BtmcOrganizationInitCommandDTO', interfaceMeta, VOID, [S2InitCommand]);
  setMetadataFor(BtmcOrganizationInitializedEventDTO, 'BtmcOrganizationInitializedEventDTO', interfaceMeta, VOID, [WithS2Id, Event]);
  setMetadataFor(BtmcSubOrganizationAddCommandDTO, 'BtmcSubOrganizationAddCommandDTO', interfaceMeta, VOID, [S2Command]);
  setMetadataFor(BtmcSubOrganizationAddedEventDTO, 'BtmcSubOrganizationAddedEventDTO', interfaceMeta, VOID, [WithS2Id, Event]);
  setMetadataFor(Companion_4, 'Companion', objectMeta);
  setMetadataFor($serializer_3, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(BtmcSubOrganizationAddCommand, 'BtmcSubOrganizationAddCommand', classMeta, VOID, [BtmcSubOrganizationAddCommandDTO], VOID, VOID, {0: $serializer_getInstance_6});
  setMetadataFor(Companion_5, 'Companion', objectMeta);
  setMetadataFor($serializer_4, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(BtmcSubOrganizationAddedEvent, 'BtmcSubOrganizationAddedEvent', classMeta, VOID, [BtmcSubOrganizationAddedEventDTO], VOID, VOID, {0: $serializer_getInstance_7});
  setMetadataFor(BtmcSubOrganizationDeleteCommandDTO, 'BtmcSubOrganizationDeleteCommandDTO', interfaceMeta, VOID, [S2Command]);
  setMetadataFor(BtmcOrganizationDeletedEventDTO, 'BtmcOrganizationDeletedEventDTO', interfaceMeta, VOID, [WithS2Id, Event]);
  setMetadataFor(Companion_6, 'Companion', objectMeta);
  setMetadataFor($serializer_5, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(BtmcSubOrganizationDeleteCommand, 'BtmcSubOrganizationDeleteCommand', classMeta, VOID, [BtmcSubOrganizationDeleteCommandDTO], VOID, VOID, {0: $serializer_getInstance_8});
  setMetadataFor(Companion_7, 'Companion', objectMeta);
  setMetadataFor($serializer_6, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(BtmcSubOrganizationDeletedEvent, 'BtmcSubOrganizationDeletedEvent', classMeta, VOID, [BtmcOrganizationDeletedEventDTO], VOID, VOID, {0: $serializer_getInstance_9});
  setMetadataFor(BtmcSubOrganizationUpdateCommandDTO, 'BtmcSubOrganizationUpdateCommandDTO', interfaceMeta, VOID, [S2Command]);
  setMetadataFor(BtmcOrganizationUpdatedEventDTO, 'BtmcOrganizationUpdatedEventDTO', interfaceMeta, VOID, [WithS2Id, Event]);
  setMetadataFor(Companion_8, 'Companion', objectMeta);
  setMetadataFor($serializer_7, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(BtmcSubOrganizationUpdateCommand, 'BtmcSubOrganizationUpdateCommand', classMeta, VOID, [BtmcSubOrganizationUpdateCommandDTO], VOID, VOID, {0: $serializer_getInstance_10});
  setMetadataFor(Companion_9, 'Companion', objectMeta);
  setMetadataFor($serializer_8, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(BtmcSubOrganizationUpdatedEvent, 'BtmcSubOrganizationUpdatedEvent', classMeta, VOID, [BtmcOrganizationUpdatedEventDTO], VOID, VOID, {0: $serializer_getInstance_11});
  setMetadataFor(BtmcOrganizationsModelDTO, 'BtmcOrganizationsModelDTO', interfaceMeta, VOID, [WithS2State, WithS2Id]);
  setMetadataFor(Companion_10, 'Companion', objectMeta);
  setMetadataFor($serializer_9, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(BtmcOrganizationsModel, 'BtmcOrganizationsModel', classMeta, VOID, [BtmcOrganizationsModelDTO], VOID, VOID, {0: $serializer_getInstance_12});
  setMetadataFor(SubOrganizationModelDTO, 'SubOrganizationModelDTO', interfaceMeta);
  setMetadataFor($serializer_10, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(SubOrganizationModel, 'SubOrganizationModel', classMeta, VOID, [SubOrganizationModelDTO], VOID, VOID, {0: $serializer_getInstance_13});
  setMetadataFor(BtmcOrganizationPolicies, 'BtmcOrganizationPolicies', objectMeta);
  setMetadataFor(BtmcOrganizationGetQueryDTO, 'BtmcOrganizationGetQueryDTO', interfaceMeta, VOID, [Query]);
  setMetadataFor(BtmcOrganizationGetResponseDTO, 'BtmcOrganizationGetResponseDTO', interfaceMeta);
  setMetadataFor(BtmcOrganizationPageQueryDTO, 'BtmcOrganizationPageQueryDTO', interfaceMeta, VOID, [PageQueryDTO]);
  setMetadataFor(BtmcOrganizationPageResponseDTO, 'BtmcOrganizationPageResponseDTO', interfaceMeta, VOID, [PageQueryResultDTO]);
  //endregion
  function _get_$cachedSerializer__te6jhj($this) {
    return $this.e5l_1.f2();
  }
  function BtmcOrganizationState$Companion$_anonymous__8p818n() {
    return createSimpleEnumSerializer('org.boislocal.platform.s2.btmcorganization.domain.automate.BtmcOrganizationState', values());
  }
  var BtmcOrganizationState_Exists_instance;
  var BtmcOrganizationState_Deleted_instance;
  function Companion() {
    Companion_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.e5l_1 = lazy(tmp_0, BtmcOrganizationState$Companion$_anonymous__8p818n);
  }
  protoOf(Companion).x14 = function () {
    return _get_$cachedSerializer__te6jhj(this);
  };
  protoOf(Companion).hu = function (typeParamsSerializers) {
    return this.x14();
  };
  var Companion_instance;
  function Companion_getInstance() {
    BtmcOrganizationState_initEntries();
    if (Companion_instance == null)
      new Companion();
    return Companion_instance;
  }
  function values() {
    return [BtmcOrganizationState_Exists_getInstance(), BtmcOrganizationState_Deleted_getInstance()];
  }
  function valueOf(value) {
    switch (value) {
      case 'Exists':
        return BtmcOrganizationState_Exists_getInstance();
      case 'Deleted':
        return BtmcOrganizationState_Deleted_getInstance();
      default:
        BtmcOrganizationState_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var BtmcOrganizationState_entriesInitialized;
  function BtmcOrganizationState_initEntries() {
    if (BtmcOrganizationState_entriesInitialized)
      return Unit_instance;
    BtmcOrganizationState_entriesInitialized = true;
    BtmcOrganizationState_Exists_instance = new BtmcOrganizationState('Exists', 0, 0);
    BtmcOrganizationState_Deleted_instance = new BtmcOrganizationState('Deleted', 1, 1);
    Companion_getInstance();
  }
  function BtmcOrganizationState(name, ordinal, position) {
    Enum.call(this, name, ordinal);
    this.h5l_1 = position;
  }
  protoOf(BtmcOrganizationState).y2c = function (_set____db54di) {
    this.h5l_1 = _set____db54di;
  };
  protoOf(BtmcOrganizationState).jr = function () {
    return this.h5l_1;
  };
  function S2$btmcOrganizationAutomate$lambda($this$s2Sourcing) {
    $this$s2Sourcing.j27_1 = 'BtmcOrganization';
    // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.transaction' call
    var builder = new S2TransitionBuilder();
    // Inline function 'org.boislocal.platform.s2.btmcorganization.domain.automate.S2.btmcOrganizationAutomate.<anonymous>.<anonymous>' call
    builder.o27_1 = BtmcOrganizationState_Exists_getInstance();
    builder.p27_1 = User_getInstance();
    // Inline function 'kotlin.let' call
    var tmp0_safe_receiver = builder.m27_1;
    var tmp = tmp0_safe_receiver == null ? null : toValue(tmp0_safe_receiver);
    var tmp_0 = toValue(builder.c24());
    var tmp_1 = toValue_0(builder.d24());
    var tmp_2 = toValue_1(getKClass(BtmcOrganizationImportCommand));
    var tmp1_elvis_lhs = builder.q27_1;
    var this_0 = new S2Transition(tmp, tmp_0, tmp_1, tmp_2, toValue_1(tmp1_elvis_lhs == null ? getKClass(BtmcOrganizationImportedEvent) : tmp1_elvis_lhs));
    // Inline function 'kotlin.contracts.contract' call
    $this$s2Sourcing.l27_1.r(this_0);
    // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.transaction' call
    var builder_0 = new S2TransitionBuilder();
    // Inline function 'org.boislocal.platform.s2.btmcorganization.domain.automate.S2.btmcOrganizationAutomate.<anonymous>.<anonymous>' call
    builder_0.o27_1 = BtmcOrganizationState_Deleted_getInstance();
    builder_0.p27_1 = User_getInstance();
    // Inline function 'kotlin.let' call
    var tmp0_safe_receiver_0 = builder_0.m27_1;
    var tmp_3 = tmp0_safe_receiver_0 == null ? null : toValue(tmp0_safe_receiver_0);
    var tmp_4 = toValue(builder_0.c24());
    var tmp_5 = toValue_0(builder_0.d24());
    var tmp_6 = toValue_1(getKClass(BtmcOrganizationImportCommand));
    var tmp1_elvis_lhs_0 = builder_0.q27_1;
    var this_1 = new S2Transition(tmp_3, tmp_4, tmp_5, tmp_6, toValue_1(tmp1_elvis_lhs_0 == null ? getKClass(BtmcOrganizationImportedEvent) : tmp1_elvis_lhs_0));
    // Inline function 'kotlin.contracts.contract' call
    $this$s2Sourcing.l27_1.r(this_1);
    // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.selfTransaction' call
    var builder_1 = new S2SelfTransitionBuilder();
    // Inline function 'org.boislocal.platform.s2.btmcorganization.domain.automate.S2.btmcOrganizationAutomate.<anonymous>.<anonymous>' call
    // Inline function 'kotlin.collections.plusAssign' call
    var this_2 = builder_1.r27_1;
    var element = BtmcOrganizationState_Exists_getInstance();
    this_2.r(element);
    builder_1.s27_1 = User_getInstance();
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.map' call
    var this_3 = builder_1.r27_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_3, 10));
    var tmp0_iterator = this_3.u();
    while (tmp0_iterator.v()) {
      var item = tmp0_iterator.w();
      // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.selfTransaction.<anonymous>' call
      var tmp_7 = toValue(item);
      var tmp_8 = toValue(item);
      var tmp_9 = toValue_0(builder_1.d24());
      var tmp_10 = toValue_1(getKClass(BtmcSubOrganizationAddCommand));
      var tmp0_elvis_lhs = builder_1.t27_1;
      var tmp$ret$4 = new S2Transition(tmp_7, tmp_8, tmp_9, tmp_10, toValue_1(tmp0_elvis_lhs == null ? getKClass(BtmcSubOrganizationAddedEvent) : tmp0_elvis_lhs));
      destination.r(tmp$ret$4);
    }
    var tmp3_forEach_receiver = $this$s2Sourcing.l27_1;
    var tmp0_iterator_0 = destination.u();
    while (tmp0_iterator_0.v()) {
      var element_0 = tmp0_iterator_0.w();
      invoke$add(tmp3_forEach_receiver, element_0);
    }
    // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.selfTransaction' call
    var builder_2 = new S2SelfTransitionBuilder();
    // Inline function 'org.boislocal.platform.s2.btmcorganization.domain.automate.S2.btmcOrganizationAutomate.<anonymous>.<anonymous>' call
    // Inline function 'kotlin.collections.plusAssign' call
    var this_4 = builder_2.r27_1;
    var element_1 = BtmcOrganizationState_Exists_getInstance();
    this_4.r(element_1);
    builder_2.s27_1 = User_getInstance();
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.map' call
    var this_5 = builder_2.r27_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(this_5, 10));
    var tmp0_iterator_1 = this_5.u();
    while (tmp0_iterator_1.v()) {
      var item_0 = tmp0_iterator_1.w();
      // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.selfTransaction.<anonymous>' call
      var tmp_11 = toValue(item_0);
      var tmp_12 = toValue(item_0);
      var tmp_13 = toValue_0(builder_2.d24());
      var tmp_14 = toValue_1(getKClass(BtmcOrganizationAssignBtmcNumberCommand));
      var tmp0_elvis_lhs_0 = builder_2.t27_1;
      var tmp$ret$8 = new S2Transition(tmp_11, tmp_12, tmp_13, tmp_14, toValue_1(tmp0_elvis_lhs_0 == null ? getKClass(BtmcOrganizationAssignedBtmcNumberEvent) : tmp0_elvis_lhs_0));
      destination_0.r(tmp$ret$8);
    }
    var tmp3_forEach_receiver_0 = $this$s2Sourcing.l27_1;
    var tmp0_iterator_2 = destination_0.u();
    while (tmp0_iterator_2.v()) {
      var element_2 = tmp0_iterator_2.w();
      invoke$add_0(tmp3_forEach_receiver_0, element_2);
    }
    // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.selfTransaction' call
    var builder_3 = new S2SelfTransitionBuilder();
    // Inline function 'org.boislocal.platform.s2.btmcorganization.domain.automate.S2.btmcOrganizationAutomate.<anonymous>.<anonymous>' call
    // Inline function 'kotlin.collections.plusAssign' call
    var this_6 = builder_3.r27_1;
    var element_3 = BtmcOrganizationState_Exists_getInstance();
    this_6.r(element_3);
    builder_3.s27_1 = User_getInstance();
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.map' call
    var this_7 = builder_3.r27_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_1 = ArrayList_init_$Create$(collectionSizeOrDefault(this_7, 10));
    var tmp0_iterator_3 = this_7.u();
    while (tmp0_iterator_3.v()) {
      var item_1 = tmp0_iterator_3.w();
      // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.selfTransaction.<anonymous>' call
      var tmp_15 = toValue(item_1);
      var tmp_16 = toValue(item_1);
      var tmp_17 = toValue_0(builder_3.d24());
      var tmp_18 = toValue_1(getKClass(BtmcSubOrganizationUpdateCommand));
      var tmp0_elvis_lhs_1 = builder_3.t27_1;
      var tmp$ret$12 = new S2Transition(tmp_15, tmp_16, tmp_17, tmp_18, toValue_1(tmp0_elvis_lhs_1 == null ? getKClass(BtmcSubOrganizationUpdatedEvent) : tmp0_elvis_lhs_1));
      destination_1.r(tmp$ret$12);
    }
    var tmp3_forEach_receiver_1 = $this$s2Sourcing.l27_1;
    var tmp0_iterator_4 = destination_1.u();
    while (tmp0_iterator_4.v()) {
      var element_4 = tmp0_iterator_4.w();
      invoke$add_1(tmp3_forEach_receiver_1, element_4);
    }
    // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.transaction' call
    var builder_4 = new S2TransitionBuilder();
    // Inline function 'org.boislocal.platform.s2.btmcorganization.domain.automate.S2.btmcOrganizationAutomate.<anonymous>.<anonymous>' call
    builder_4.m27_1 = BtmcOrganizationState_Exists_getInstance();
    builder_4.o27_1 = BtmcOrganizationState_Exists_getInstance();
    builder_4.p27_1 = User_getInstance();
    // Inline function 'kotlin.let' call
    var tmp0_safe_receiver_1 = builder_4.m27_1;
    var tmp_19 = tmp0_safe_receiver_1 == null ? null : toValue(tmp0_safe_receiver_1);
    var tmp_20 = toValue(builder_4.c24());
    var tmp_21 = toValue_0(builder_4.d24());
    var tmp_22 = toValue_1(getKClass(BtmcSubOrganizationDeleteCommand));
    var tmp1_elvis_lhs_1 = builder_4.q27_1;
    var this_8 = new S2Transition(tmp_19, tmp_20, tmp_21, tmp_22, toValue_1(tmp1_elvis_lhs_1 == null ? getKClass(BtmcSubOrganizationDeletedEvent) : tmp1_elvis_lhs_1));
    // Inline function 'kotlin.contracts.contract' call
    $this$s2Sourcing.l27_1.r(this_8);
    return Unit_instance;
  }
  function invoke$add(receiver, p0) {
    receiver.r(p0);
  }
  function invoke$add_0(receiver, p0) {
    receiver.r(p0);
  }
  function invoke$add_1(receiver, p0) {
    receiver.r(p0);
  }
  function S2() {
    S2_instance = this;
    var tmp = this;
    tmp.i5l_1 = s2Sourcing(S2$btmcOrganizationAutomate$lambda);
  }
  var S2_instance;
  function S2_getInstance() {
    if (S2_instance == null)
      new S2();
    return S2_instance;
  }
  function User() {
    User_instance = this;
    UserRole.call(this, 'User');
  }
  var User_instance;
  function User_getInstance() {
    if (User_instance == null)
      new User();
    return User_instance;
  }
  function Companion_0() {
  }
  var Companion_instance_0;
  function Companion_getInstance_0() {
    return Companion_instance_0;
  }
  function $serializer() {
    $serializer_instance = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.btmcorganization.domain.automate.UserRole', this, 1);
    tmp0_serialDesc.ht('name', false);
    this.k5l_1 = tmp0_serialDesc;
  }
  protoOf($serializer).ii = function () {
    return this.k5l_1;
  };
  protoOf($serializer).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  };
  protoOf($serializer).ki = function (decoder) {
    var tmp0_desc = this.k5l_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.ul(tmp0_desc);
    if (tmp5_input.km()) {
      tmp4_local0 = tmp5_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.vl(tmp0_desc);
    return UserRole_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer).l5l = function (encoder, value) {
    var tmp0_desc = this.k5l_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.h9());
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer).ji = function (encoder, value) {
    return this.l5l(encoder, value instanceof UserRole ? value : THROW_CCE());
  };
  var $serializer_instance;
  function $serializer_getInstance_2() {
    if ($serializer_instance == null)
      new $serializer();
    return $serializer_instance;
  }
  function UserRole_init_$Init$(seen1, name, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen1))) {
      throwMissingFieldException(seen1, 1, $serializer_getInstance_2().k5l_1);
    }
    $this.j5l_1 = name;
    return $this;
  }
  function UserRole_init_$Create$(seen1, name, serializationConstructorMarker) {
    return UserRole_init_$Init$(seen1, name, serializationConstructorMarker, objectCreate(protoOf(UserRole)));
  }
  function UserRole(name) {
    this.j5l_1 = name;
  }
  protoOf(UserRole).h9 = function () {
    return this.j5l_1;
  };
  protoOf(UserRole).toString = function () {
    return this.h9();
  };
  function BtmcOrganizationState_Exists_getInstance() {
    BtmcOrganizationState_initEntries();
    return BtmcOrganizationState_Exists_instance;
  }
  function BtmcOrganizationState_Deleted_getInstance() {
    BtmcOrganizationState_initEntries();
    return BtmcOrganizationState_Deleted_instance;
  }
  function BtmcOrganizationAssignBtmcNumberCommandDTO() {
  }
  function BtmcOrganizationAssignedBtmcNumberEventDTO() {
  }
  function BtmcOrganizationAssignBtmcNumberCommand(id, btmcNumber, img) {
    this.n5l_1 = id;
    this.o5l_1 = btmcNumber;
    this.p5l_1 = img;
  }
  protoOf(BtmcOrganizationAssignBtmcNumberCommand).k1y = function () {
    return this.n5l_1;
  };
  protoOf(BtmcOrganizationAssignBtmcNumberCommand).m5l = function () {
    return this.o5l_1;
  };
  protoOf(BtmcOrganizationAssignBtmcNumberCommand).d2d = function () {
    return this.p5l_1;
  };
  protoOf(BtmcOrganizationAssignBtmcNumberCommand).toString = function () {
    return 'BtmcOrganizationAssignBtmcNumberCommand(id=' + this.n5l_1 + ', btmcNumber=' + this.o5l_1 + ', img=' + this.p5l_1 + ')';
  };
  protoOf(BtmcOrganizationAssignBtmcNumberCommand).hashCode = function () {
    var result = getStringHashCode(this.n5l_1);
    result = imul(result, 31) + getStringHashCode(this.o5l_1) | 0;
    result = imul(result, 31) + (this.p5l_1 == null ? 0 : getStringHashCode(this.p5l_1)) | 0;
    return result;
  };
  protoOf(BtmcOrganizationAssignBtmcNumberCommand).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BtmcOrganizationAssignBtmcNumberCommand))
      return false;
    var tmp0_other_with_cast = other instanceof BtmcOrganizationAssignBtmcNumberCommand ? other : THROW_CCE();
    if (!(this.n5l_1 === tmp0_other_with_cast.n5l_1))
      return false;
    if (!(this.o5l_1 === tmp0_other_with_cast.o5l_1))
      return false;
    if (!(this.p5l_1 == tmp0_other_with_cast.p5l_1))
      return false;
    return true;
  };
  function Companion_1() {
  }
  var Companion_instance_1;
  function Companion_getInstance_1() {
    return Companion_instance_1;
  }
  function $serializer_0() {
    $serializer_instance_0 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('BtmcOrganizationAssignedBtmcNumberEvent', this, 4);
    tmp0_serialDesc.ht('id', false);
    tmp0_serialDesc.ht('btmcNumber', false);
    tmp0_serialDesc.ht('img', false);
    tmp0_serialDesc.ht('time', false);
    this.q5l_1 = tmp0_serialDesc;
  }
  protoOf($serializer_0).ii = function () {
    return this.q5l_1;
  };
  protoOf($serializer_0).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable($serializer_getInstance()), LongSerializer_getInstance()];
  };
  protoOf($serializer_0).ki = function (decoder) {
    var tmp0_desc = this.q5l_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = new Long(0, 0);
    var tmp8_input = decoder.ul(tmp0_desc);
    if (tmp8_input.km()) {
      tmp4_local0 = tmp8_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.em(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.im(tmp0_desc, 2, $serializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.am(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.em(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.im(tmp0_desc, 2, $serializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.am(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.vl(tmp0_desc);
    return BtmcOrganizationAssignedBtmcNumberEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_0).r5l = function (encoder, value) {
    var tmp0_desc = this.q5l_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.s5l_1);
    tmp1_output.jn(tmp0_desc, 1, value.t5l_1);
    tmp1_output.nn(tmp0_desc, 2, $serializer_getInstance(), value.u5l_1);
    tmp1_output.fn(tmp0_desc, 3, value.v5l_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_0).ji = function (encoder, value) {
    return this.r5l(encoder, value instanceof BtmcOrganizationAssignedBtmcNumberEvent ? value : THROW_CCE());
  };
  var $serializer_instance_0;
  function $serializer_getInstance_3() {
    if ($serializer_instance_0 == null)
      new $serializer_0();
    return $serializer_instance_0;
  }
  function BtmcOrganizationAssignedBtmcNumberEvent_init_$Init$(seen1, id, btmcNumber, img, time, serializationConstructorMarker, $this) {
    if (!(15 === (15 & seen1))) {
      throwMissingFieldException(seen1, 15, $serializer_getInstance_3().q5l_1);
    }
    $this.s5l_1 = id;
    $this.t5l_1 = btmcNumber;
    $this.u5l_1 = img;
    $this.v5l_1 = time;
    return $this;
  }
  function BtmcOrganizationAssignedBtmcNumberEvent_init_$Create$(seen1, id, btmcNumber, img, time, serializationConstructorMarker) {
    return BtmcOrganizationAssignedBtmcNumberEvent_init_$Init$(seen1, id, btmcNumber, img, time, serializationConstructorMarker, objectCreate(protoOf(BtmcOrganizationAssignedBtmcNumberEvent)));
  }
  function BtmcOrganizationAssignedBtmcNumberEvent(id, btmcNumber, img, time) {
    this.s5l_1 = id;
    this.t5l_1 = btmcNumber;
    this.u5l_1 = img;
    this.v5l_1 = time;
  }
  protoOf(BtmcOrganizationAssignedBtmcNumberEvent).k1y = function () {
    return this.s5l_1;
  };
  protoOf(BtmcOrganizationAssignedBtmcNumberEvent).m5l = function () {
    return this.t5l_1;
  };
  protoOf(BtmcOrganizationAssignedBtmcNumberEvent).d2d = function () {
    return this.u5l_1;
  };
  protoOf(BtmcOrganizationAssignedBtmcNumberEvent).g2c = function () {
    return this.v5l_1;
  };
  protoOf(BtmcOrganizationAssignedBtmcNumberEvent).s2Id = function () {
    return this.s5l_1;
  };
  protoOf(BtmcOrganizationAssignedBtmcNumberEvent).toString = function () {
    return 'BtmcOrganizationAssignedBtmcNumberEvent(id=' + this.s5l_1 + ', btmcNumber=' + this.t5l_1 + ', img=' + this.u5l_1 + ', time=' + this.v5l_1.toString() + ')';
  };
  protoOf(BtmcOrganizationAssignedBtmcNumberEvent).hashCode = function () {
    var result = getStringHashCode(this.s5l_1);
    result = imul(result, 31) + getStringHashCode(this.t5l_1) | 0;
    result = imul(result, 31) + (this.u5l_1 == null ? 0 : this.u5l_1.hashCode()) | 0;
    result = imul(result, 31) + this.v5l_1.hashCode() | 0;
    return result;
  };
  protoOf(BtmcOrganizationAssignedBtmcNumberEvent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BtmcOrganizationAssignedBtmcNumberEvent))
      return false;
    var tmp0_other_with_cast = other instanceof BtmcOrganizationAssignedBtmcNumberEvent ? other : THROW_CCE();
    if (!(this.s5l_1 === tmp0_other_with_cast.s5l_1))
      return false;
    if (!(this.t5l_1 === tmp0_other_with_cast.t5l_1))
      return false;
    if (!equals(this.u5l_1, tmp0_other_with_cast.u5l_1))
      return false;
    if (!this.v5l_1.equals(tmp0_other_with_cast.v5l_1))
      return false;
    return true;
  };
  function BtmcOrganizationImportCommandDTO() {
  }
  function BtmcOrganizationImportedEventDTO() {
  }
  function Companion_2() {
  }
  var Companion_instance_2;
  function Companion_getInstance_2() {
    return Companion_instance_2;
  }
  function $serializer_1() {
    $serializer_instance_1 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.btmcorganization.domain.command.BtmcOrganizationImportCommand', this, 1);
    tmp0_serialDesc.ht('item', false);
    this.w5l_1 = tmp0_serialDesc;
  }
  protoOf($serializer_1).ii = function () {
    return this.w5l_1;
  };
  protoOf($serializer_1).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_12()];
  };
  protoOf($serializer_1).ki = function (decoder) {
    var tmp0_desc = this.w5l_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.ul(tmp0_desc);
    if (tmp5_input.km()) {
      tmp4_local0 = tmp5_input.gm(tmp0_desc, 0, $serializer_getInstance_12(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.gm(tmp0_desc, 0, $serializer_getInstance_12(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.vl(tmp0_desc);
    return BtmcOrganizationImportCommand_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_1).x5l = function (encoder, value) {
    var tmp0_desc = this.w5l_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.ln(tmp0_desc, 0, $serializer_getInstance_12(), value.y5l_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_1).ji = function (encoder, value) {
    return this.x5l(encoder, value instanceof BtmcOrganizationImportCommand ? value : THROW_CCE());
  };
  var $serializer_instance_1;
  function $serializer_getInstance_4() {
    if ($serializer_instance_1 == null)
      new $serializer_1();
    return $serializer_instance_1;
  }
  function BtmcOrganizationImportCommand_init_$Init$(seen1, item, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen1))) {
      throwMissingFieldException(seen1, 1, $serializer_getInstance_4().w5l_1);
    }
    $this.y5l_1 = item;
    return $this;
  }
  function BtmcOrganizationImportCommand_init_$Create$(seen1, item, serializationConstructorMarker) {
    return BtmcOrganizationImportCommand_init_$Init$(seen1, item, serializationConstructorMarker, objectCreate(protoOf(BtmcOrganizationImportCommand)));
  }
  function BtmcOrganizationImportCommand(item) {
    this.y5l_1 = item;
  }
  protoOf(BtmcOrganizationImportCommand).q20 = function () {
    return this.y5l_1;
  };
  protoOf(BtmcOrganizationImportCommand).toString = function () {
    return 'BtmcOrganizationImportCommand(item=' + this.y5l_1 + ')';
  };
  protoOf(BtmcOrganizationImportCommand).hashCode = function () {
    return this.y5l_1.hashCode();
  };
  protoOf(BtmcOrganizationImportCommand).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BtmcOrganizationImportCommand))
      return false;
    var tmp0_other_with_cast = other instanceof BtmcOrganizationImportCommand ? other : THROW_CCE();
    if (!this.y5l_1.equals(tmp0_other_with_cast.y5l_1))
      return false;
    return true;
  };
  function Companion_3() {
  }
  var Companion_instance_3;
  function Companion_getInstance_3() {
    return Companion_instance_3;
  }
  function $serializer_2() {
    $serializer_instance_2 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('BtmcOrganizationImportedEvent', this, 2);
    tmp0_serialDesc.ht('item', false);
    tmp0_serialDesc.ht('time', false);
    this.z5l_1 = tmp0_serialDesc;
  }
  protoOf($serializer_2).ii = function () {
    return this.z5l_1;
  };
  protoOf($serializer_2).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_12(), LongSerializer_getInstance()];
  };
  protoOf($serializer_2).ki = function (decoder) {
    var tmp0_desc = this.z5l_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = new Long(0, 0);
    var tmp6_input = decoder.ul(tmp0_desc);
    if (tmp6_input.km()) {
      tmp4_local0 = tmp6_input.gm(tmp0_desc, 0, $serializer_getInstance_12(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.am(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.gm(tmp0_desc, 0, $serializer_getInstance_12(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.am(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.vl(tmp0_desc);
    return BtmcOrganizationImportedEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_2).a5m = function (encoder, value) {
    var tmp0_desc = this.z5l_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.ln(tmp0_desc, 0, $serializer_getInstance_12(), value.b5m_1);
    tmp1_output.fn(tmp0_desc, 1, value.c5m_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_2).ji = function (encoder, value) {
    return this.a5m(encoder, value instanceof BtmcOrganizationImportedEvent ? value : THROW_CCE());
  };
  var $serializer_instance_2;
  function $serializer_getInstance_5() {
    if ($serializer_instance_2 == null)
      new $serializer_2();
    return $serializer_instance_2;
  }
  function BtmcOrganizationImportedEvent_init_$Init$(seen1, item, time, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen1))) {
      throwMissingFieldException(seen1, 3, $serializer_getInstance_5().z5l_1);
    }
    $this.b5m_1 = item;
    $this.c5m_1 = time;
    return $this;
  }
  function BtmcOrganizationImportedEvent_init_$Create$(seen1, item, time, serializationConstructorMarker) {
    return BtmcOrganizationImportedEvent_init_$Init$(seen1, item, time, serializationConstructorMarker, objectCreate(protoOf(BtmcOrganizationImportedEvent)));
  }
  function BtmcOrganizationImportedEvent(item, time) {
    this.b5m_1 = item;
    this.c5m_1 = time;
  }
  protoOf(BtmcOrganizationImportedEvent).q20 = function () {
    return this.b5m_1;
  };
  protoOf(BtmcOrganizationImportedEvent).g2c = function () {
    return this.c5m_1;
  };
  protoOf(BtmcOrganizationImportedEvent).s2Id = function () {
    return this.b5m_1.d5m_1;
  };
  protoOf(BtmcOrganizationImportedEvent).toString = function () {
    return 'BtmcOrganizationImportedEvent(item=' + this.b5m_1 + ', time=' + this.c5m_1.toString() + ')';
  };
  protoOf(BtmcOrganizationImportedEvent).hashCode = function () {
    var result = this.b5m_1.hashCode();
    result = imul(result, 31) + this.c5m_1.hashCode() | 0;
    return result;
  };
  protoOf(BtmcOrganizationImportedEvent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BtmcOrganizationImportedEvent))
      return false;
    var tmp0_other_with_cast = other instanceof BtmcOrganizationImportedEvent ? other : THROW_CCE();
    if (!this.b5m_1.equals(tmp0_other_with_cast.b5m_1))
      return false;
    if (!this.c5m_1.equals(tmp0_other_with_cast.c5m_1))
      return false;
    return true;
  };
  function BtmcOrganizationInitCommandDTO() {
  }
  function BtmcOrganizationInitializedEventDTO() {
  }
  function BtmcSubOrganizationAddCommandDTO() {
  }
  function BtmcSubOrganizationAddedEventDTO() {
  }
  function Companion_4() {
  }
  var Companion_instance_4;
  function Companion_getInstance_4() {
    return Companion_instance_4;
  }
  function $serializer_3() {
    $serializer_instance_3 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.btmcorganization.domain.command.BtmcSubOrganizationAddCommand', this, 4);
    tmp0_serialDesc.ht('id', false);
    tmp0_serialDesc.ht('name', false);
    tmp0_serialDesc.ht('address', false);
    tmp0_serialDesc.ht('geo', false);
    this.j5m_1 = tmp0_serialDesc;
  }
  protoOf($serializer_3).ii = function () {
    return this.j5m_1;
  };
  protoOf($serializer_3).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), $serializer_getInstance_0(), get_nullable($serializer_getInstance_1())];
  };
  protoOf($serializer_3).ki = function (decoder) {
    var tmp0_desc = this.j5m_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.ul(tmp0_desc);
    if (tmp8_input.km()) {
      tmp4_local0 = tmp8_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.em(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.gm(tmp0_desc, 2, $serializer_getInstance_0(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.im(tmp0_desc, 3, $serializer_getInstance_1(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.em(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.gm(tmp0_desc, 2, $serializer_getInstance_0(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.im(tmp0_desc, 3, $serializer_getInstance_1(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.vl(tmp0_desc);
    return BtmcSubOrganizationAddCommand_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_3).k5m = function (encoder, value) {
    var tmp0_desc = this.j5m_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.l5m_1);
    tmp1_output.jn(tmp0_desc, 1, value.m5m_1);
    tmp1_output.ln(tmp0_desc, 2, $serializer_getInstance_0(), value.n5m_1);
    tmp1_output.nn(tmp0_desc, 3, $serializer_getInstance_1(), value.o5m_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_3).ji = function (encoder, value) {
    return this.k5m(encoder, value instanceof BtmcSubOrganizationAddCommand ? value : THROW_CCE());
  };
  var $serializer_instance_3;
  function $serializer_getInstance_6() {
    if ($serializer_instance_3 == null)
      new $serializer_3();
    return $serializer_instance_3;
  }
  function BtmcSubOrganizationAddCommand_init_$Init$(seen1, id, name, address, geo, serializationConstructorMarker, $this) {
    if (!(15 === (15 & seen1))) {
      throwMissingFieldException(seen1, 15, $serializer_getInstance_6().j5m_1);
    }
    $this.l5m_1 = id;
    $this.m5m_1 = name;
    $this.n5m_1 = address;
    $this.o5m_1 = geo;
    return $this;
  }
  function BtmcSubOrganizationAddCommand_init_$Create$(seen1, id, name, address, geo, serializationConstructorMarker) {
    return BtmcSubOrganizationAddCommand_init_$Init$(seen1, id, name, address, geo, serializationConstructorMarker, objectCreate(protoOf(BtmcSubOrganizationAddCommand)));
  }
  function BtmcSubOrganizationAddCommand(id, name, address, geo) {
    this.l5m_1 = id;
    this.m5m_1 = name;
    this.n5m_1 = address;
    this.o5m_1 = geo;
  }
  protoOf(BtmcSubOrganizationAddCommand).k1y = function () {
    return this.l5m_1;
  };
  protoOf(BtmcSubOrganizationAddCommand).h9 = function () {
    return this.m5m_1;
  };
  protoOf(BtmcSubOrganizationAddCommand).x29 = function () {
    return this.n5m_1;
  };
  protoOf(BtmcSubOrganizationAddCommand).b2p = function () {
    return this.o5m_1;
  };
  protoOf(BtmcSubOrganizationAddCommand).toString = function () {
    return 'BtmcSubOrganizationAddCommand(id=' + this.l5m_1 + ', name=' + this.m5m_1 + ', address=' + this.n5m_1 + ', geo=' + this.o5m_1 + ')';
  };
  protoOf(BtmcSubOrganizationAddCommand).hashCode = function () {
    var result = getStringHashCode(this.l5m_1);
    result = imul(result, 31) + getStringHashCode(this.m5m_1) | 0;
    result = imul(result, 31) + this.n5m_1.hashCode() | 0;
    result = imul(result, 31) + (this.o5m_1 == null ? 0 : this.o5m_1.hashCode()) | 0;
    return result;
  };
  protoOf(BtmcSubOrganizationAddCommand).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BtmcSubOrganizationAddCommand))
      return false;
    var tmp0_other_with_cast = other instanceof BtmcSubOrganizationAddCommand ? other : THROW_CCE();
    if (!(this.l5m_1 === tmp0_other_with_cast.l5m_1))
      return false;
    if (!(this.m5m_1 === tmp0_other_with_cast.m5m_1))
      return false;
    if (!this.n5m_1.equals(tmp0_other_with_cast.n5m_1))
      return false;
    if (!equals(this.o5m_1, tmp0_other_with_cast.o5m_1))
      return false;
    return true;
  };
  function Companion_5() {
  }
  var Companion_instance_5;
  function Companion_getInstance_5() {
    return Companion_instance_5;
  }
  function $serializer_4() {
    $serializer_instance_4 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('BtmcSubOrganizationAddedEvent', this, 6);
    tmp0_serialDesc.ht('id', false);
    tmp0_serialDesc.ht('subOrganizationId', false);
    tmp0_serialDesc.ht('name', false);
    tmp0_serialDesc.ht('address', false);
    tmp0_serialDesc.ht('geo', false);
    tmp0_serialDesc.ht('time', false);
    this.p5m_1 = tmp0_serialDesc;
  }
  protoOf($serializer_4).ii = function () {
    return this.p5m_1;
  };
  protoOf($serializer_4).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), $serializer_getInstance_0(), get_nullable($serializer_getInstance_1()), LongSerializer_getInstance()];
  };
  protoOf($serializer_4).ki = function (decoder) {
    var tmp0_desc = this.p5m_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = new Long(0, 0);
    var tmp10_input = decoder.ul(tmp0_desc);
    if (tmp10_input.km()) {
      tmp4_local0 = tmp10_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp10_input.em(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp10_input.em(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp10_input.gm(tmp0_desc, 3, $serializer_getInstance_0(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp10_input.im(tmp0_desc, 4, $serializer_getInstance_1(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp10_input.am(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp10_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp10_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp10_input.em(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp10_input.em(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp10_input.gm(tmp0_desc, 3, $serializer_getInstance_0(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp10_input.im(tmp0_desc, 4, $serializer_getInstance_1(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp10_input.am(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp10_input.vl(tmp0_desc);
    return BtmcSubOrganizationAddedEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
  };
  protoOf($serializer_4).q5m = function (encoder, value) {
    var tmp0_desc = this.p5m_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.r5m_1);
    tmp1_output.jn(tmp0_desc, 1, value.s5m_1);
    tmp1_output.jn(tmp0_desc, 2, value.t5m_1);
    tmp1_output.ln(tmp0_desc, 3, $serializer_getInstance_0(), value.u5m_1);
    tmp1_output.nn(tmp0_desc, 4, $serializer_getInstance_1(), value.v5m_1);
    tmp1_output.fn(tmp0_desc, 5, value.w5m_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_4).ji = function (encoder, value) {
    return this.q5m(encoder, value instanceof BtmcSubOrganizationAddedEvent ? value : THROW_CCE());
  };
  var $serializer_instance_4;
  function $serializer_getInstance_7() {
    if ($serializer_instance_4 == null)
      new $serializer_4();
    return $serializer_instance_4;
  }
  function BtmcSubOrganizationAddedEvent_init_$Init$(seen1, id, subOrganizationId, name, address, geo, time, serializationConstructorMarker, $this) {
    if (!(63 === (63 & seen1))) {
      throwMissingFieldException(seen1, 63, $serializer_getInstance_7().p5m_1);
    }
    $this.r5m_1 = id;
    $this.s5m_1 = subOrganizationId;
    $this.t5m_1 = name;
    $this.u5m_1 = address;
    $this.v5m_1 = geo;
    $this.w5m_1 = time;
    return $this;
  }
  function BtmcSubOrganizationAddedEvent_init_$Create$(seen1, id, subOrganizationId, name, address, geo, time, serializationConstructorMarker) {
    return BtmcSubOrganizationAddedEvent_init_$Init$(seen1, id, subOrganizationId, name, address, geo, time, serializationConstructorMarker, objectCreate(protoOf(BtmcSubOrganizationAddedEvent)));
  }
  function BtmcSubOrganizationAddedEvent(id, subOrganizationId, name, address, geo, time) {
    this.r5m_1 = id;
    this.s5m_1 = subOrganizationId;
    this.t5m_1 = name;
    this.u5m_1 = address;
    this.v5m_1 = geo;
    this.w5m_1 = time;
  }
  protoOf(BtmcSubOrganizationAddedEvent).k1y = function () {
    return this.r5m_1;
  };
  protoOf(BtmcSubOrganizationAddedEvent).i5m = function () {
    return this.s5m_1;
  };
  protoOf(BtmcSubOrganizationAddedEvent).h9 = function () {
    return this.t5m_1;
  };
  protoOf(BtmcSubOrganizationAddedEvent).x29 = function () {
    return this.u5m_1;
  };
  protoOf(BtmcSubOrganizationAddedEvent).b2p = function () {
    return this.v5m_1;
  };
  protoOf(BtmcSubOrganizationAddedEvent).g2c = function () {
    return this.w5m_1;
  };
  protoOf(BtmcSubOrganizationAddedEvent).s2Id = function () {
    return this.r5m_1;
  };
  protoOf(BtmcSubOrganizationAddedEvent).toString = function () {
    return 'BtmcSubOrganizationAddedEvent(id=' + this.r5m_1 + ', subOrganizationId=' + this.s5m_1 + ', name=' + this.t5m_1 + ', address=' + this.u5m_1 + ', geo=' + this.v5m_1 + ', time=' + this.w5m_1.toString() + ')';
  };
  protoOf(BtmcSubOrganizationAddedEvent).hashCode = function () {
    var result = getStringHashCode(this.r5m_1);
    result = imul(result, 31) + getStringHashCode(this.s5m_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.t5m_1) | 0;
    result = imul(result, 31) + this.u5m_1.hashCode() | 0;
    result = imul(result, 31) + (this.v5m_1 == null ? 0 : this.v5m_1.hashCode()) | 0;
    result = imul(result, 31) + this.w5m_1.hashCode() | 0;
    return result;
  };
  protoOf(BtmcSubOrganizationAddedEvent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BtmcSubOrganizationAddedEvent))
      return false;
    var tmp0_other_with_cast = other instanceof BtmcSubOrganizationAddedEvent ? other : THROW_CCE();
    if (!(this.r5m_1 === tmp0_other_with_cast.r5m_1))
      return false;
    if (!(this.s5m_1 === tmp0_other_with_cast.s5m_1))
      return false;
    if (!(this.t5m_1 === tmp0_other_with_cast.t5m_1))
      return false;
    if (!this.u5m_1.equals(tmp0_other_with_cast.u5m_1))
      return false;
    if (!equals(this.v5m_1, tmp0_other_with_cast.v5m_1))
      return false;
    if (!this.w5m_1.equals(tmp0_other_with_cast.w5m_1))
      return false;
    return true;
  };
  function BtmcSubOrganizationDeleteCommandDTO() {
  }
  function BtmcOrganizationDeletedEventDTO() {
  }
  function Companion_6() {
  }
  var Companion_instance_6;
  function Companion_getInstance_6() {
    return Companion_instance_6;
  }
  function $serializer_5() {
    $serializer_instance_5 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.btmcorganization.domain.command.BtmcSubOrganizationDeleteCommand', this, 2);
    tmp0_serialDesc.ht('id', false);
    tmp0_serialDesc.ht('subOrganizationId', false);
    this.x5m_1 = tmp0_serialDesc;
  }
  protoOf($serializer_5).ii = function () {
    return this.x5m_1;
  };
  protoOf($serializer_5).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance()];
  };
  protoOf($serializer_5).ki = function (decoder) {
    var tmp0_desc = this.x5m_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.ul(tmp0_desc);
    if (tmp6_input.km()) {
      tmp4_local0 = tmp6_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.em(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.em(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.vl(tmp0_desc);
    return BtmcSubOrganizationDeleteCommand_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_5).y5m = function (encoder, value) {
    var tmp0_desc = this.x5m_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.z5m_1);
    tmp1_output.jn(tmp0_desc, 1, value.a5n_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_5).ji = function (encoder, value) {
    return this.y5m(encoder, value instanceof BtmcSubOrganizationDeleteCommand ? value : THROW_CCE());
  };
  var $serializer_instance_5;
  function $serializer_getInstance_8() {
    if ($serializer_instance_5 == null)
      new $serializer_5();
    return $serializer_instance_5;
  }
  function BtmcSubOrganizationDeleteCommand_init_$Init$(seen1, id, subOrganizationId, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen1))) {
      throwMissingFieldException(seen1, 3, $serializer_getInstance_8().x5m_1);
    }
    $this.z5m_1 = id;
    $this.a5n_1 = subOrganizationId;
    return $this;
  }
  function BtmcSubOrganizationDeleteCommand_init_$Create$(seen1, id, subOrganizationId, serializationConstructorMarker) {
    return BtmcSubOrganizationDeleteCommand_init_$Init$(seen1, id, subOrganizationId, serializationConstructorMarker, objectCreate(protoOf(BtmcSubOrganizationDeleteCommand)));
  }
  function BtmcSubOrganizationDeleteCommand(id, subOrganizationId) {
    this.z5m_1 = id;
    this.a5n_1 = subOrganizationId;
  }
  protoOf(BtmcSubOrganizationDeleteCommand).k1y = function () {
    return this.z5m_1;
  };
  protoOf(BtmcSubOrganizationDeleteCommand).i5m = function () {
    return this.a5n_1;
  };
  protoOf(BtmcSubOrganizationDeleteCommand).toString = function () {
    return 'BtmcSubOrganizationDeleteCommand(id=' + this.z5m_1 + ', subOrganizationId=' + this.a5n_1 + ')';
  };
  protoOf(BtmcSubOrganizationDeleteCommand).hashCode = function () {
    var result = getStringHashCode(this.z5m_1);
    result = imul(result, 31) + getStringHashCode(this.a5n_1) | 0;
    return result;
  };
  protoOf(BtmcSubOrganizationDeleteCommand).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BtmcSubOrganizationDeleteCommand))
      return false;
    var tmp0_other_with_cast = other instanceof BtmcSubOrganizationDeleteCommand ? other : THROW_CCE();
    if (!(this.z5m_1 === tmp0_other_with_cast.z5m_1))
      return false;
    if (!(this.a5n_1 === tmp0_other_with_cast.a5n_1))
      return false;
    return true;
  };
  function Companion_7() {
  }
  var Companion_instance_7;
  function Companion_getInstance_7() {
    return Companion_instance_7;
  }
  function $serializer_6() {
    $serializer_instance_6 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('BtmcSubOrganizationDeletedEvent', this, 3);
    tmp0_serialDesc.ht('id', false);
    tmp0_serialDesc.ht('subOrganizationId', false);
    tmp0_serialDesc.ht('time', false);
    this.b5n_1 = tmp0_serialDesc;
  }
  protoOf($serializer_6).ii = function () {
    return this.b5n_1;
  };
  protoOf($serializer_6).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), LongSerializer_getInstance()];
  };
  protoOf($serializer_6).ki = function (decoder) {
    var tmp0_desc = this.b5n_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = new Long(0, 0);
    var tmp7_input = decoder.ul(tmp0_desc);
    if (tmp7_input.km()) {
      tmp4_local0 = tmp7_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.em(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.am(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.em(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.am(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.vl(tmp0_desc);
    return BtmcSubOrganizationDeletedEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_6).c5n = function (encoder, value) {
    var tmp0_desc = this.b5n_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.d5n_1);
    tmp1_output.jn(tmp0_desc, 1, value.e5n_1);
    tmp1_output.fn(tmp0_desc, 2, value.f5n_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_6).ji = function (encoder, value) {
    return this.c5n(encoder, value instanceof BtmcSubOrganizationDeletedEvent ? value : THROW_CCE());
  };
  var $serializer_instance_6;
  function $serializer_getInstance_9() {
    if ($serializer_instance_6 == null)
      new $serializer_6();
    return $serializer_instance_6;
  }
  function BtmcSubOrganizationDeletedEvent_init_$Init$(seen1, id, subOrganizationId, time, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen1))) {
      throwMissingFieldException(seen1, 7, $serializer_getInstance_9().b5n_1);
    }
    $this.d5n_1 = id;
    $this.e5n_1 = subOrganizationId;
    $this.f5n_1 = time;
    return $this;
  }
  function BtmcSubOrganizationDeletedEvent_init_$Create$(seen1, id, subOrganizationId, time, serializationConstructorMarker) {
    return BtmcSubOrganizationDeletedEvent_init_$Init$(seen1, id, subOrganizationId, time, serializationConstructorMarker, objectCreate(protoOf(BtmcSubOrganizationDeletedEvent)));
  }
  function BtmcSubOrganizationDeletedEvent(id, subOrganizationId, time) {
    this.d5n_1 = id;
    this.e5n_1 = subOrganizationId;
    this.f5n_1 = time;
  }
  protoOf(BtmcSubOrganizationDeletedEvent).k1y = function () {
    return this.d5n_1;
  };
  protoOf(BtmcSubOrganizationDeletedEvent).i5m = function () {
    return this.e5n_1;
  };
  protoOf(BtmcSubOrganizationDeletedEvent).g2c = function () {
    return this.f5n_1;
  };
  protoOf(BtmcSubOrganizationDeletedEvent).s2Id = function () {
    return this.d5n_1;
  };
  protoOf(BtmcSubOrganizationDeletedEvent).toString = function () {
    return 'BtmcSubOrganizationDeletedEvent(id=' + this.d5n_1 + ', subOrganizationId=' + this.e5n_1 + ', time=' + this.f5n_1.toString() + ')';
  };
  protoOf(BtmcSubOrganizationDeletedEvent).hashCode = function () {
    var result = getStringHashCode(this.d5n_1);
    result = imul(result, 31) + getStringHashCode(this.e5n_1) | 0;
    result = imul(result, 31) + this.f5n_1.hashCode() | 0;
    return result;
  };
  protoOf(BtmcSubOrganizationDeletedEvent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BtmcSubOrganizationDeletedEvent))
      return false;
    var tmp0_other_with_cast = other instanceof BtmcSubOrganizationDeletedEvent ? other : THROW_CCE();
    if (!(this.d5n_1 === tmp0_other_with_cast.d5n_1))
      return false;
    if (!(this.e5n_1 === tmp0_other_with_cast.e5n_1))
      return false;
    if (!this.f5n_1.equals(tmp0_other_with_cast.f5n_1))
      return false;
    return true;
  };
  function BtmcSubOrganizationUpdateCommandDTO() {
  }
  function BtmcOrganizationUpdatedEventDTO() {
  }
  function Companion_8() {
  }
  var Companion_instance_8;
  function Companion_getInstance_8() {
    return Companion_instance_8;
  }
  function $serializer_7() {
    $serializer_instance_7 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.btmcorganization.domain.command.BtmcSubOrganizationUpdateCommand', this, 5);
    tmp0_serialDesc.ht('id', false);
    tmp0_serialDesc.ht('subOrganizationId', false);
    tmp0_serialDesc.ht('name', false);
    tmp0_serialDesc.ht('address', false);
    tmp0_serialDesc.ht('geo', false);
    this.g5n_1 = tmp0_serialDesc;
  }
  protoOf($serializer_7).ii = function () {
    return this.g5n_1;
  };
  protoOf($serializer_7).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), $serializer_getInstance_0(), get_nullable($serializer_getInstance_1())];
  };
  protoOf($serializer_7).ki = function (decoder) {
    var tmp0_desc = this.g5n_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_input = decoder.ul(tmp0_desc);
    if (tmp9_input.km()) {
      tmp4_local0 = tmp9_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.em(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.em(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.gm(tmp0_desc, 3, $serializer_getInstance_0(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.im(tmp0_desc, 4, $serializer_getInstance_1(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.em(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.em(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.gm(tmp0_desc, 3, $serializer_getInstance_0(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.im(tmp0_desc, 4, $serializer_getInstance_1(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp9_input.vl(tmp0_desc);
    return BtmcSubOrganizationUpdateCommand_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  };
  protoOf($serializer_7).h5n = function (encoder, value) {
    var tmp0_desc = this.g5n_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.i5n_1);
    tmp1_output.jn(tmp0_desc, 1, value.j5n_1);
    tmp1_output.jn(tmp0_desc, 2, value.k5n_1);
    tmp1_output.ln(tmp0_desc, 3, $serializer_getInstance_0(), value.l5n_1);
    tmp1_output.nn(tmp0_desc, 4, $serializer_getInstance_1(), value.m5n_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_7).ji = function (encoder, value) {
    return this.h5n(encoder, value instanceof BtmcSubOrganizationUpdateCommand ? value : THROW_CCE());
  };
  var $serializer_instance_7;
  function $serializer_getInstance_10() {
    if ($serializer_instance_7 == null)
      new $serializer_7();
    return $serializer_instance_7;
  }
  function BtmcSubOrganizationUpdateCommand_init_$Init$(seen1, id, subOrganizationId, name, address, geo, serializationConstructorMarker, $this) {
    if (!(31 === (31 & seen1))) {
      throwMissingFieldException(seen1, 31, $serializer_getInstance_10().g5n_1);
    }
    $this.i5n_1 = id;
    $this.j5n_1 = subOrganizationId;
    $this.k5n_1 = name;
    $this.l5n_1 = address;
    $this.m5n_1 = geo;
    return $this;
  }
  function BtmcSubOrganizationUpdateCommand_init_$Create$(seen1, id, subOrganizationId, name, address, geo, serializationConstructorMarker) {
    return BtmcSubOrganizationUpdateCommand_init_$Init$(seen1, id, subOrganizationId, name, address, geo, serializationConstructorMarker, objectCreate(protoOf(BtmcSubOrganizationUpdateCommand)));
  }
  function BtmcSubOrganizationUpdateCommand(id, subOrganizationId, name, address, geo) {
    this.i5n_1 = id;
    this.j5n_1 = subOrganizationId;
    this.k5n_1 = name;
    this.l5n_1 = address;
    this.m5n_1 = geo;
  }
  protoOf(BtmcSubOrganizationUpdateCommand).k1y = function () {
    return this.i5n_1;
  };
  protoOf(BtmcSubOrganizationUpdateCommand).i5m = function () {
    return this.j5n_1;
  };
  protoOf(BtmcSubOrganizationUpdateCommand).h9 = function () {
    return this.k5n_1;
  };
  protoOf(BtmcSubOrganizationUpdateCommand).x29 = function () {
    return this.l5n_1;
  };
  protoOf(BtmcSubOrganizationUpdateCommand).b2p = function () {
    return this.m5n_1;
  };
  protoOf(BtmcSubOrganizationUpdateCommand).toString = function () {
    return 'BtmcSubOrganizationUpdateCommand(id=' + this.i5n_1 + ', subOrganizationId=' + this.j5n_1 + ', name=' + this.k5n_1 + ', address=' + this.l5n_1 + ', geo=' + this.m5n_1 + ')';
  };
  protoOf(BtmcSubOrganizationUpdateCommand).hashCode = function () {
    var result = getStringHashCode(this.i5n_1);
    result = imul(result, 31) + getStringHashCode(this.j5n_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.k5n_1) | 0;
    result = imul(result, 31) + this.l5n_1.hashCode() | 0;
    result = imul(result, 31) + (this.m5n_1 == null ? 0 : this.m5n_1.hashCode()) | 0;
    return result;
  };
  protoOf(BtmcSubOrganizationUpdateCommand).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BtmcSubOrganizationUpdateCommand))
      return false;
    var tmp0_other_with_cast = other instanceof BtmcSubOrganizationUpdateCommand ? other : THROW_CCE();
    if (!(this.i5n_1 === tmp0_other_with_cast.i5n_1))
      return false;
    if (!(this.j5n_1 === tmp0_other_with_cast.j5n_1))
      return false;
    if (!(this.k5n_1 === tmp0_other_with_cast.k5n_1))
      return false;
    if (!this.l5n_1.equals(tmp0_other_with_cast.l5n_1))
      return false;
    if (!equals(this.m5n_1, tmp0_other_with_cast.m5n_1))
      return false;
    return true;
  };
  function Companion_9() {
  }
  var Companion_instance_9;
  function Companion_getInstance_9() {
    return Companion_instance_9;
  }
  function $serializer_8() {
    $serializer_instance_8 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('BtmcSubOrganizationUpdatedEvent', this, 6);
    tmp0_serialDesc.ht('id', false);
    tmp0_serialDesc.ht('subOrganizationId', false);
    tmp0_serialDesc.ht('name', false);
    tmp0_serialDesc.ht('address', false);
    tmp0_serialDesc.ht('geo', false);
    tmp0_serialDesc.ht('time', false);
    this.n5n_1 = tmp0_serialDesc;
  }
  protoOf($serializer_8).ii = function () {
    return this.n5n_1;
  };
  protoOf($serializer_8).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), $serializer_getInstance_0(), get_nullable($serializer_getInstance_1()), LongSerializer_getInstance()];
  };
  protoOf($serializer_8).ki = function (decoder) {
    var tmp0_desc = this.n5n_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = new Long(0, 0);
    var tmp10_input = decoder.ul(tmp0_desc);
    if (tmp10_input.km()) {
      tmp4_local0 = tmp10_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp10_input.em(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp10_input.em(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp10_input.gm(tmp0_desc, 3, $serializer_getInstance_0(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp10_input.im(tmp0_desc, 4, $serializer_getInstance_1(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp10_input.am(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp10_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp10_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp10_input.em(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp10_input.em(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp10_input.gm(tmp0_desc, 3, $serializer_getInstance_0(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp10_input.im(tmp0_desc, 4, $serializer_getInstance_1(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp10_input.am(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp10_input.vl(tmp0_desc);
    return BtmcSubOrganizationUpdatedEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
  };
  protoOf($serializer_8).o5n = function (encoder, value) {
    var tmp0_desc = this.n5n_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.p5n_1);
    tmp1_output.jn(tmp0_desc, 1, value.q5n_1);
    tmp1_output.jn(tmp0_desc, 2, value.r5n_1);
    tmp1_output.ln(tmp0_desc, 3, $serializer_getInstance_0(), value.s5n_1);
    tmp1_output.nn(tmp0_desc, 4, $serializer_getInstance_1(), value.t5n_1);
    tmp1_output.fn(tmp0_desc, 5, value.u5n_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_8).ji = function (encoder, value) {
    return this.o5n(encoder, value instanceof BtmcSubOrganizationUpdatedEvent ? value : THROW_CCE());
  };
  var $serializer_instance_8;
  function $serializer_getInstance_11() {
    if ($serializer_instance_8 == null)
      new $serializer_8();
    return $serializer_instance_8;
  }
  function BtmcSubOrganizationUpdatedEvent_init_$Init$(seen1, id, subOrganizationId, name, address, geo, time, serializationConstructorMarker, $this) {
    if (!(63 === (63 & seen1))) {
      throwMissingFieldException(seen1, 63, $serializer_getInstance_11().n5n_1);
    }
    $this.p5n_1 = id;
    $this.q5n_1 = subOrganizationId;
    $this.r5n_1 = name;
    $this.s5n_1 = address;
    $this.t5n_1 = geo;
    $this.u5n_1 = time;
    return $this;
  }
  function BtmcSubOrganizationUpdatedEvent_init_$Create$(seen1, id, subOrganizationId, name, address, geo, time, serializationConstructorMarker) {
    return BtmcSubOrganizationUpdatedEvent_init_$Init$(seen1, id, subOrganizationId, name, address, geo, time, serializationConstructorMarker, objectCreate(protoOf(BtmcSubOrganizationUpdatedEvent)));
  }
  function BtmcSubOrganizationUpdatedEvent(id, subOrganizationId, name, address, geo, time) {
    this.p5n_1 = id;
    this.q5n_1 = subOrganizationId;
    this.r5n_1 = name;
    this.s5n_1 = address;
    this.t5n_1 = geo;
    this.u5n_1 = time;
  }
  protoOf(BtmcSubOrganizationUpdatedEvent).k1y = function () {
    return this.p5n_1;
  };
  protoOf(BtmcSubOrganizationUpdatedEvent).i5m = function () {
    return this.q5n_1;
  };
  protoOf(BtmcSubOrganizationUpdatedEvent).h9 = function () {
    return this.r5n_1;
  };
  protoOf(BtmcSubOrganizationUpdatedEvent).x29 = function () {
    return this.s5n_1;
  };
  protoOf(BtmcSubOrganizationUpdatedEvent).b2p = function () {
    return this.t5n_1;
  };
  protoOf(BtmcSubOrganizationUpdatedEvent).g2c = function () {
    return this.u5n_1;
  };
  protoOf(BtmcSubOrganizationUpdatedEvent).s2Id = function () {
    return this.p5n_1;
  };
  protoOf(BtmcSubOrganizationUpdatedEvent).toString = function () {
    return 'BtmcSubOrganizationUpdatedEvent(id=' + this.p5n_1 + ', subOrganizationId=' + this.q5n_1 + ', name=' + this.r5n_1 + ', address=' + this.s5n_1 + ', geo=' + this.t5n_1 + ', time=' + this.u5n_1.toString() + ')';
  };
  protoOf(BtmcSubOrganizationUpdatedEvent).hashCode = function () {
    var result = getStringHashCode(this.p5n_1);
    result = imul(result, 31) + getStringHashCode(this.q5n_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.r5n_1) | 0;
    result = imul(result, 31) + this.s5n_1.hashCode() | 0;
    result = imul(result, 31) + (this.t5n_1 == null ? 0 : this.t5n_1.hashCode()) | 0;
    result = imul(result, 31) + this.u5n_1.hashCode() | 0;
    return result;
  };
  protoOf(BtmcSubOrganizationUpdatedEvent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BtmcSubOrganizationUpdatedEvent))
      return false;
    var tmp0_other_with_cast = other instanceof BtmcSubOrganizationUpdatedEvent ? other : THROW_CCE();
    if (!(this.p5n_1 === tmp0_other_with_cast.p5n_1))
      return false;
    if (!(this.q5n_1 === tmp0_other_with_cast.q5n_1))
      return false;
    if (!(this.r5n_1 === tmp0_other_with_cast.r5n_1))
      return false;
    if (!this.s5n_1.equals(tmp0_other_with_cast.s5n_1))
      return false;
    if (!equals(this.t5n_1, tmp0_other_with_cast.t5n_1))
      return false;
    if (!this.u5n_1.equals(tmp0_other_with_cast.u5n_1))
      return false;
    return true;
  };
  function BtmcOrganizationsModelDTO() {
  }
  function Companion_10() {
    Companion_instance_10 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.w5n_1 = [null, Companion_getInstance().x14(), null, null, new ArrayListSerializer($serializer_getInstance_13())];
  }
  var Companion_instance_10;
  function Companion_getInstance_10() {
    if (Companion_instance_10 == null)
      new Companion_10();
    return Companion_instance_10;
  }
  function $serializer_9() {
    $serializer_instance_9 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.btmcorganization.domain.model.BtmcOrganizationsModel', this, 5);
    tmp0_serialDesc.ht('id', false);
    tmp0_serialDesc.ht('status', false);
    tmp0_serialDesc.ht('btmcNumber', false);
    tmp0_serialDesc.ht('img', false);
    tmp0_serialDesc.ht('subOrganizations', false);
    this.x5n_1 = tmp0_serialDesc;
  }
  protoOf($serializer_9).ii = function () {
    return this.x5n_1;
  };
  protoOf($serializer_9).wt = function () {
    var tmp0_cached = Companion_getInstance_10().w5n_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), tmp0_cached[1], get_nullable(StringSerializer_getInstance()), get_nullable($serializer_getInstance()), tmp0_cached[4]];
  };
  protoOf($serializer_9).ki = function (decoder) {
    var tmp0_desc = this.x5n_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_input = decoder.ul(tmp0_desc);
    var tmp10_cached = Companion_getInstance_10().w5n_1;
    if (tmp9_input.km()) {
      tmp4_local0 = tmp9_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.gm(tmp0_desc, 1, tmp10_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.im(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.im(tmp0_desc, 3, $serializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.gm(tmp0_desc, 4, tmp10_cached[4], tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.gm(tmp0_desc, 1, tmp10_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.im(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.im(tmp0_desc, 3, $serializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.gm(tmp0_desc, 4, tmp10_cached[4], tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp9_input.vl(tmp0_desc);
    return BtmcOrganizationsModel_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  };
  protoOf($serializer_9).y5n = function (encoder, value) {
    var tmp0_desc = this.x5n_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    var tmp2_cached = Companion_getInstance_10().w5n_1;
    tmp1_output.jn(tmp0_desc, 0, value.d5m_1);
    tmp1_output.ln(tmp0_desc, 1, tmp2_cached[1], value.e5m_1);
    tmp1_output.nn(tmp0_desc, 2, StringSerializer_getInstance(), value.f5m_1);
    tmp1_output.nn(tmp0_desc, 3, $serializer_getInstance(), value.g5m_1);
    tmp1_output.ln(tmp0_desc, 4, tmp2_cached[4], value.h5m_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_9).ji = function (encoder, value) {
    return this.y5n(encoder, value instanceof BtmcOrganizationsModel ? value : THROW_CCE());
  };
  var $serializer_instance_9;
  function $serializer_getInstance_12() {
    if ($serializer_instance_9 == null)
      new $serializer_9();
    return $serializer_instance_9;
  }
  function BtmcOrganizationsModel_init_$Init$(seen1, id, status, btmcNumber, img, subOrganizations, serializationConstructorMarker, $this) {
    if (!(31 === (31 & seen1))) {
      throwMissingFieldException(seen1, 31, $serializer_getInstance_12().x5n_1);
    }
    $this.d5m_1 = id;
    $this.e5m_1 = status;
    $this.f5m_1 = btmcNumber;
    $this.g5m_1 = img;
    $this.h5m_1 = subOrganizations;
    return $this;
  }
  function BtmcOrganizationsModel_init_$Create$(seen1, id, status, btmcNumber, img, subOrganizations, serializationConstructorMarker) {
    return BtmcOrganizationsModel_init_$Init$(seen1, id, status, btmcNumber, img, subOrganizations, serializationConstructorMarker, objectCreate(protoOf(BtmcOrganizationsModel)));
  }
  function BtmcOrganizationsModel() {
  }
  protoOf(BtmcOrganizationsModel).k1y = function () {
    return this.d5m_1;
  };
  protoOf(BtmcOrganizationsModel).y2f = function () {
    return this.e5m_1;
  };
  protoOf(BtmcOrganizationsModel).m5l = function () {
    return this.f5m_1;
  };
  protoOf(BtmcOrganizationsModel).d2d = function () {
    return this.g5m_1;
  };
  protoOf(BtmcOrganizationsModel).v5n = function () {
    return this.h5m_1;
  };
  protoOf(BtmcOrganizationsModel).s2State = function () {
    return this.e5m_1;
  };
  protoOf(BtmcOrganizationsModel).s2Id = function () {
    return this.d5m_1;
  };
  protoOf(BtmcOrganizationsModel).toString = function () {
    return 'BtmcOrganizationsModel(id=' + this.d5m_1 + ', status=' + this.e5m_1 + ', btmcNumber=' + this.f5m_1 + ', img=' + this.g5m_1 + ', subOrganizations=' + this.h5m_1 + ')';
  };
  protoOf(BtmcOrganizationsModel).hashCode = function () {
    var result = getStringHashCode(this.d5m_1);
    result = imul(result, 31) + this.e5m_1.hashCode() | 0;
    result = imul(result, 31) + (this.f5m_1 == null ? 0 : getStringHashCode(this.f5m_1)) | 0;
    result = imul(result, 31) + (this.g5m_1 == null ? 0 : this.g5m_1.hashCode()) | 0;
    result = imul(result, 31) + hashCode(this.h5m_1) | 0;
    return result;
  };
  protoOf(BtmcOrganizationsModel).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BtmcOrganizationsModel))
      return false;
    var tmp0_other_with_cast = other instanceof BtmcOrganizationsModel ? other : THROW_CCE();
    if (!(this.d5m_1 === tmp0_other_with_cast.d5m_1))
      return false;
    if (!this.e5m_1.equals(tmp0_other_with_cast.e5m_1))
      return false;
    if (!(this.f5m_1 == tmp0_other_with_cast.f5m_1))
      return false;
    if (!equals(this.g5m_1, tmp0_other_with_cast.g5m_1))
      return false;
    if (!equals(this.h5m_1, tmp0_other_with_cast.h5m_1))
      return false;
    return true;
  };
  function SubOrganizationModelDTO() {
  }
  function $serializer_10() {
    $serializer_instance_10 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.btmcorganization.domain.model.SubOrganizationModel', this, 4);
    tmp0_serialDesc.ht('id', false);
    tmp0_serialDesc.ht('name', false);
    tmp0_serialDesc.ht('address', false);
    tmp0_serialDesc.ht('geo', false);
    this.z5n_1 = tmp0_serialDesc;
  }
  protoOf($serializer_10).ii = function () {
    return this.z5n_1;
  };
  protoOf($serializer_10).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), $serializer_getInstance_0(), get_nullable($serializer_getInstance_1())];
  };
  protoOf($serializer_10).ki = function (decoder) {
    var tmp0_desc = this.z5n_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.ul(tmp0_desc);
    if (tmp8_input.km()) {
      tmp4_local0 = tmp8_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.em(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.gm(tmp0_desc, 2, $serializer_getInstance_0(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.im(tmp0_desc, 3, $serializer_getInstance_1(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.em(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.gm(tmp0_desc, 2, $serializer_getInstance_0(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.im(tmp0_desc, 3, $serializer_getInstance_1(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.vl(tmp0_desc);
    return SubOrganizationModel_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_10).a5o = function (encoder, value) {
    var tmp0_desc = this.z5n_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.b5o_1);
    tmp1_output.jn(tmp0_desc, 1, value.c5o_1);
    tmp1_output.ln(tmp0_desc, 2, $serializer_getInstance_0(), value.d5o_1);
    tmp1_output.nn(tmp0_desc, 3, $serializer_getInstance_1(), value.e5o_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_10).ji = function (encoder, value) {
    return this.a5o(encoder, value instanceof SubOrganizationModel ? value : THROW_CCE());
  };
  var $serializer_instance_10;
  function $serializer_getInstance_13() {
    if ($serializer_instance_10 == null)
      new $serializer_10();
    return $serializer_instance_10;
  }
  function SubOrganizationModel_init_$Init$(seen1, id, name, address, geo, serializationConstructorMarker, $this) {
    if (!(15 === (15 & seen1))) {
      throwMissingFieldException(seen1, 15, $serializer_getInstance_13().z5n_1);
    }
    $this.b5o_1 = id;
    $this.c5o_1 = name;
    $this.d5o_1 = address;
    $this.e5o_1 = geo;
    return $this;
  }
  function SubOrganizationModel_init_$Create$(seen1, id, name, address, geo, serializationConstructorMarker) {
    return SubOrganizationModel_init_$Init$(seen1, id, name, address, geo, serializationConstructorMarker, objectCreate(protoOf(SubOrganizationModel)));
  }
  function SubOrganizationModel() {
  }
  protoOf(SubOrganizationModel).k1y = function () {
    return this.b5o_1;
  };
  protoOf(SubOrganizationModel).h9 = function () {
    return this.c5o_1;
  };
  protoOf(SubOrganizationModel).x29 = function () {
    return this.d5o_1;
  };
  protoOf(SubOrganizationModel).b2p = function () {
    return this.e5o_1;
  };
  protoOf(SubOrganizationModel).toString = function () {
    return 'SubOrganizationModel(id=' + this.b5o_1 + ', name=' + this.c5o_1 + ', address=' + this.d5o_1 + ', geo=' + this.e5o_1 + ')';
  };
  protoOf(SubOrganizationModel).hashCode = function () {
    var result = getStringHashCode(this.b5o_1);
    result = imul(result, 31) + getStringHashCode(this.c5o_1) | 0;
    result = imul(result, 31) + this.d5o_1.hashCode() | 0;
    result = imul(result, 31) + (this.e5o_1 == null ? 0 : this.e5o_1.hashCode()) | 0;
    return result;
  };
  protoOf(SubOrganizationModel).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SubOrganizationModel))
      return false;
    var tmp0_other_with_cast = other instanceof SubOrganizationModel ? other : THROW_CCE();
    if (!(this.b5o_1 === tmp0_other_with_cast.b5o_1))
      return false;
    if (!(this.c5o_1 === tmp0_other_with_cast.c5o_1))
      return false;
    if (!this.d5o_1.equals(tmp0_other_with_cast.d5o_1))
      return false;
    if (!equals(this.e5o_1, tmp0_other_with_cast.e5o_1))
      return false;
    return true;
  };
  function BtmcOrganizationPolicies() {
  }
  protoOf(BtmcOrganizationPolicies).canPage = function (authedUser) {
    return true;
  };
  protoOf(BtmcOrganizationPolicies).canGet = function (authedUser) {
    return true;
  };
  protoOf(BtmcOrganizationPolicies).caninit = function (authedUser) {
    return hasRole(authedUser, 'Marque');
  };
  protoOf(BtmcOrganizationPolicies).canAdd = function (authedUser) {
    return hasRole(authedUser, 'Marque');
  };
  protoOf(BtmcOrganizationPolicies).canUpdate = function (authedUser, target) {
    // Inline function 'org.boislocal.platform.s2.commons.domain.model.canExecuteTransitionAnd' call
    var this_0 = S2_getInstance().i5l_1;
    var tmp;
    if (isAvailableTransition(this_0, target, ensureNotNull(getKClass(BtmcSubOrganizationUpdateCommand).z5()))) {
      // Inline function 'org.boislocal.platform.s2.btmcorganization.domain.policy.BtmcOrganizationPolicies.canUpdate.<anonymous>' call
      tmp = hasRole(authedUser, 'Marque');
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(BtmcOrganizationPolicies).canDelete = function (authedUser, target) {
    // Inline function 'org.boislocal.platform.s2.commons.domain.model.canExecuteTransitionAnd' call
    var this_0 = S2_getInstance().i5l_1;
    var tmp;
    if (isAvailableTransition(this_0, target, ensureNotNull(getKClass(BtmcSubOrganizationDeleteCommand).z5()))) {
      // Inline function 'org.boislocal.platform.s2.btmcorganization.domain.policy.BtmcOrganizationPolicies.canDelete.<anonymous>' call
      tmp = hasRole(authedUser, 'Marque');
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(BtmcOrganizationPolicies).canAssignBtmcNumber = function (authedUser, target) {
    // Inline function 'org.boislocal.platform.s2.commons.domain.model.canExecuteTransitionAnd' call
    var this_0 = S2_getInstance().i5l_1;
    var tmp;
    if (isAvailableTransition(this_0, target, ensureNotNull(getKClass(BtmcOrganizationAssignBtmcNumberCommand).z5()))) {
      // Inline function 'org.boislocal.platform.s2.btmcorganization.domain.policy.BtmcOrganizationPolicies.canAssignBtmcNumber.<anonymous>' call
      tmp = hasRole(authedUser, 'Marque');
    } else {
      tmp = false;
    }
    return tmp;
  };
  var BtmcOrganizationPolicies_instance;
  function BtmcOrganizationPolicies_getInstance() {
    return BtmcOrganizationPolicies_instance;
  }
  function BtmcOrganizationGetQueryDTO() {
  }
  function BtmcOrganizationGetResponseDTO() {
  }
  function BtmcOrganizationPageQueryDTO() {
  }
  function BtmcOrganizationPageResponseDTO() {
  }
  //region block: post-declaration
  defineProp(protoOf(BtmcOrganizationState), 'position', function () {
    return this.jr();
  }, function (value) {
    this.y2c(value);
  });
  defineProp(protoOf(BtmcOrganizationState), 'name', protoOf(BtmcOrganizationState).h9);
  defineProp(protoOf(BtmcOrganizationState), 'ordinal', protoOf(BtmcOrganizationState).i9);
  protoOf($serializer).xt = typeParametersSerializers;
  defineProp(protoOf(BtmcOrganizationAssignBtmcNumberCommand), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(BtmcOrganizationAssignBtmcNumberCommand), 'btmcNumber', function () {
    return this.m5l();
  });
  defineProp(protoOf(BtmcOrganizationAssignBtmcNumberCommand), 'img', function () {
    return this.d2d();
  });
  protoOf($serializer_0).xt = typeParametersSerializers;
  defineProp(protoOf(BtmcOrganizationAssignedBtmcNumberEvent), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(BtmcOrganizationAssignedBtmcNumberEvent), 'btmcNumber', function () {
    return this.m5l();
  });
  defineProp(protoOf(BtmcOrganizationAssignedBtmcNumberEvent), 'img', function () {
    return this.d2d();
  });
  defineProp(protoOf(BtmcOrganizationAssignedBtmcNumberEvent), 'time', function () {
    return this.g2c();
  });
  protoOf($serializer_1).xt = typeParametersSerializers;
  defineProp(protoOf(BtmcOrganizationImportCommand), 'item', function () {
    return this.q20();
  });
  protoOf($serializer_2).xt = typeParametersSerializers;
  defineProp(protoOf(BtmcOrganizationImportedEvent), 'item', function () {
    return this.q20();
  });
  defineProp(protoOf(BtmcOrganizationImportedEvent), 'time', function () {
    return this.g2c();
  });
  protoOf($serializer_3).xt = typeParametersSerializers;
  defineProp(protoOf(BtmcSubOrganizationAddCommand), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(BtmcSubOrganizationAddCommand), 'name', function () {
    return this.h9();
  });
  defineProp(protoOf(BtmcSubOrganizationAddCommand), 'address', function () {
    return this.x29();
  });
  defineProp(protoOf(BtmcSubOrganizationAddCommand), 'geo', function () {
    return this.b2p();
  });
  protoOf($serializer_4).xt = typeParametersSerializers;
  defineProp(protoOf(BtmcSubOrganizationAddedEvent), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(BtmcSubOrganizationAddedEvent), 'subOrganizationId', function () {
    return this.i5m();
  });
  defineProp(protoOf(BtmcSubOrganizationAddedEvent), 'name', function () {
    return this.h9();
  });
  defineProp(protoOf(BtmcSubOrganizationAddedEvent), 'address', function () {
    return this.x29();
  });
  defineProp(protoOf(BtmcSubOrganizationAddedEvent), 'geo', function () {
    return this.b2p();
  });
  defineProp(protoOf(BtmcSubOrganizationAddedEvent), 'time', function () {
    return this.g2c();
  });
  protoOf($serializer_5).xt = typeParametersSerializers;
  defineProp(protoOf(BtmcSubOrganizationDeleteCommand), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(BtmcSubOrganizationDeleteCommand), 'subOrganizationId', function () {
    return this.i5m();
  });
  protoOf($serializer_6).xt = typeParametersSerializers;
  defineProp(protoOf(BtmcSubOrganizationDeletedEvent), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(BtmcSubOrganizationDeletedEvent), 'subOrganizationId', function () {
    return this.i5m();
  });
  defineProp(protoOf(BtmcSubOrganizationDeletedEvent), 'time', function () {
    return this.g2c();
  });
  protoOf($serializer_7).xt = typeParametersSerializers;
  defineProp(protoOf(BtmcSubOrganizationUpdateCommand), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(BtmcSubOrganizationUpdateCommand), 'subOrganizationId', function () {
    return this.i5m();
  });
  defineProp(protoOf(BtmcSubOrganizationUpdateCommand), 'name', function () {
    return this.h9();
  });
  defineProp(protoOf(BtmcSubOrganizationUpdateCommand), 'address', function () {
    return this.x29();
  });
  defineProp(protoOf(BtmcSubOrganizationUpdateCommand), 'geo', function () {
    return this.b2p();
  });
  protoOf($serializer_8).xt = typeParametersSerializers;
  defineProp(protoOf(BtmcSubOrganizationUpdatedEvent), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(BtmcSubOrganizationUpdatedEvent), 'subOrganizationId', function () {
    return this.i5m();
  });
  defineProp(protoOf(BtmcSubOrganizationUpdatedEvent), 'name', function () {
    return this.h9();
  });
  defineProp(protoOf(BtmcSubOrganizationUpdatedEvent), 'address', function () {
    return this.x29();
  });
  defineProp(protoOf(BtmcSubOrganizationUpdatedEvent), 'geo', function () {
    return this.b2p();
  });
  defineProp(protoOf(BtmcSubOrganizationUpdatedEvent), 'time', function () {
    return this.g2c();
  });
  protoOf($serializer_9).xt = typeParametersSerializers;
  defineProp(protoOf(BtmcOrganizationsModel), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(BtmcOrganizationsModel), 'status', function () {
    return this.y2f();
  });
  defineProp(protoOf(BtmcOrganizationsModel), 'btmcNumber', function () {
    return this.m5l();
  });
  defineProp(protoOf(BtmcOrganizationsModel), 'img', function () {
    return this.d2d();
  });
  defineProp(protoOf(BtmcOrganizationsModel), 'subOrganizations', function () {
    return this.v5n();
  });
  protoOf($serializer_10).xt = typeParametersSerializers;
  defineProp(protoOf(SubOrganizationModel), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(SubOrganizationModel), 'name', function () {
    return this.h9();
  });
  defineProp(protoOf(SubOrganizationModel), 'address', function () {
    return this.x29();
  });
  defineProp(protoOf(SubOrganizationModel), 'geo', function () {
    return this.b2p();
  });
  //endregion
  //region block: init
  Companion_instance_0 = new Companion_0();
  Companion_instance_1 = new Companion_1();
  Companion_instance_2 = new Companion_2();
  Companion_instance_3 = new Companion_3();
  Companion_instance_4 = new Companion_4();
  Companion_instance_5 = new Companion_5();
  Companion_instance_6 = new Companion_6();
  Companion_instance_7 = new Companion_7();
  Companion_instance_8 = new Companion_8();
  Companion_instance_9 = new Companion_9();
  BtmcOrganizationPolicies_instance = new BtmcOrganizationPolicies();
  //endregion
  //region block: exports
  function $jsExportAll$(_) {
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$btmcorganization = $org$boislocal$platform$s2.btmcorganization || ($org$boislocal$platform$s2.btmcorganization = {});
    var $org$boislocal$platform$s2$btmcorganization$domain = $org$boislocal$platform$s2$btmcorganization.domain || ($org$boislocal$platform$s2$btmcorganization.domain = {});
    var $org$boislocal$platform$s2$btmcorganization$domain$automate = $org$boislocal$platform$s2$btmcorganization$domain.automate || ($org$boislocal$platform$s2$btmcorganization$domain.automate = {});
    $org$boislocal$platform$s2$btmcorganization$domain$automate.BtmcOrganizationState = BtmcOrganizationState;
    $org$boislocal$platform$s2$btmcorganization$domain$automate.BtmcOrganizationState.values = values;
    $org$boislocal$platform$s2$btmcorganization$domain$automate.BtmcOrganizationState.valueOf = valueOf;
    defineProp($org$boislocal$platform$s2$btmcorganization$domain$automate.BtmcOrganizationState, 'Exists', BtmcOrganizationState_Exists_getInstance);
    defineProp($org$boislocal$platform$s2$btmcorganization$domain$automate.BtmcOrganizationState, 'Deleted', BtmcOrganizationState_Deleted_getInstance);
    defineProp($org$boislocal$platform$s2$btmcorganization$domain$automate.BtmcOrganizationState, 'Companion', Companion_getInstance);
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$btmcorganization = $org$boislocal$platform$s2.btmcorganization || ($org$boislocal$platform$s2.btmcorganization = {});
    var $org$boislocal$platform$s2$btmcorganization$domain = $org$boislocal$platform$s2$btmcorganization.domain || ($org$boislocal$platform$s2$btmcorganization.domain = {});
    var $org$boislocal$platform$s2$btmcorganization$domain$command = $org$boislocal$platform$s2$btmcorganization$domain.command || ($org$boislocal$platform$s2$btmcorganization$domain.command = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$btmcorganization = $org$boislocal$platform$s2.btmcorganization || ($org$boislocal$platform$s2.btmcorganization = {});
    var $org$boislocal$platform$s2$btmcorganization$domain = $org$boislocal$platform$s2$btmcorganization.domain || ($org$boislocal$platform$s2$btmcorganization.domain = {});
    var $org$boislocal$platform$s2$btmcorganization$domain$command = $org$boislocal$platform$s2$btmcorganization$domain.command || ($org$boislocal$platform$s2$btmcorganization$domain.command = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$btmcorganization = $org$boislocal$platform$s2.btmcorganization || ($org$boislocal$platform$s2.btmcorganization = {});
    var $org$boislocal$platform$s2$btmcorganization$domain = $org$boislocal$platform$s2$btmcorganization.domain || ($org$boislocal$platform$s2$btmcorganization.domain = {});
    var $org$boislocal$platform$s2$btmcorganization$domain$command = $org$boislocal$platform$s2$btmcorganization$domain.command || ($org$boislocal$platform$s2$btmcorganization$domain.command = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$btmcorganization = $org$boislocal$platform$s2.btmcorganization || ($org$boislocal$platform$s2.btmcorganization = {});
    var $org$boislocal$platform$s2$btmcorganization$domain = $org$boislocal$platform$s2$btmcorganization.domain || ($org$boislocal$platform$s2$btmcorganization.domain = {});
    var $org$boislocal$platform$s2$btmcorganization$domain$command = $org$boislocal$platform$s2$btmcorganization$domain.command || ($org$boislocal$platform$s2$btmcorganization$domain.command = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$btmcorganization = $org$boislocal$platform$s2.btmcorganization || ($org$boislocal$platform$s2.btmcorganization = {});
    var $org$boislocal$platform$s2$btmcorganization$domain = $org$boislocal$platform$s2$btmcorganization.domain || ($org$boislocal$platform$s2$btmcorganization.domain = {});
    var $org$boislocal$platform$s2$btmcorganization$domain$command = $org$boislocal$platform$s2$btmcorganization$domain.command || ($org$boislocal$platform$s2$btmcorganization$domain.command = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$btmcorganization = $org$boislocal$platform$s2.btmcorganization || ($org$boislocal$platform$s2.btmcorganization = {});
    var $org$boislocal$platform$s2$btmcorganization$domain = $org$boislocal$platform$s2$btmcorganization.domain || ($org$boislocal$platform$s2$btmcorganization.domain = {});
    var $org$boislocal$platform$s2$btmcorganization$domain$command = $org$boislocal$platform$s2$btmcorganization$domain.command || ($org$boislocal$platform$s2$btmcorganization$domain.command = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$btmcorganization = $org$boislocal$platform$s2.btmcorganization || ($org$boislocal$platform$s2.btmcorganization = {});
    var $org$boislocal$platform$s2$btmcorganization$domain = $org$boislocal$platform$s2$btmcorganization.domain || ($org$boislocal$platform$s2$btmcorganization.domain = {});
    var $org$boislocal$platform$s2$btmcorganization$domain$model = $org$boislocal$platform$s2$btmcorganization$domain.model || ($org$boislocal$platform$s2$btmcorganization$domain.model = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$btmcorganization = $org$boislocal$platform$s2.btmcorganization || ($org$boislocal$platform$s2.btmcorganization = {});
    var $org$boislocal$platform$s2$btmcorganization$domain = $org$boislocal$platform$s2$btmcorganization.domain || ($org$boislocal$platform$s2$btmcorganization.domain = {});
    var $org$boislocal$platform$s2$btmcorganization$domain$model = $org$boislocal$platform$s2$btmcorganization$domain.model || ($org$boislocal$platform$s2$btmcorganization$domain.model = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$btmcorganization = $org$boislocal$platform$s2.btmcorganization || ($org$boislocal$platform$s2.btmcorganization = {});
    var $org$boislocal$platform$s2$btmcorganization$domain = $org$boislocal$platform$s2$btmcorganization.domain || ($org$boislocal$platform$s2$btmcorganization.domain = {});
    var $org$boislocal$platform$s2$btmcorganization$domain$policy = $org$boislocal$platform$s2$btmcorganization$domain.policy || ($org$boislocal$platform$s2$btmcorganization$domain.policy = {});
    defineProp($org$boislocal$platform$s2$btmcorganization$domain$policy, 'BtmcOrganizationPolicies', BtmcOrganizationPolicies_getInstance);
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$btmcorganization = $org$boislocal$platform$s2.btmcorganization || ($org$boislocal$platform$s2.btmcorganization = {});
    var $org$boislocal$platform$s2$btmcorganization$domain = $org$boislocal$platform$s2$btmcorganization.domain || ($org$boislocal$platform$s2$btmcorganization.domain = {});
    var $org$boislocal$platform$s2$btmcorganization$domain$query = $org$boislocal$platform$s2$btmcorganization$domain.query || ($org$boislocal$platform$s2$btmcorganization$domain.query = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$btmcorganization = $org$boislocal$platform$s2.btmcorganization || ($org$boislocal$platform$s2.btmcorganization = {});
    var $org$boislocal$platform$s2$btmcorganization$domain = $org$boislocal$platform$s2$btmcorganization.domain || ($org$boislocal$platform$s2$btmcorganization.domain = {});
    var $org$boislocal$platform$s2$btmcorganization$domain$query = $org$boislocal$platform$s2$btmcorganization$domain.query || ($org$boislocal$platform$s2$btmcorganization$domain.query = {});
  }
  $jsExportAll$(_);
  _.$jsExportAll$ = $jsExportAll$;
  //endregion
  return _;
}));

//# sourceMappingURL=boislocal-platform-platform-s2-btmcOrganization-btmcOrganization-domain.js.map
